// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCRd6Amu-LX67mha4GX0UCcHcFgLVNnKX8",
  authDomain: "mu-qess.firebaseapp.com",
  projectId: "mu-qess",
  storageBucket: "mu-qess.firebasestorage.app",
  messagingSenderId: "826397666621",
  appId: "1:826397666621:web:a946a13c20005f2f556954",
  measurementId: "G-21HPFXD8WP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export {app, firestore, auth, analytics };